import { MetricsChart } from 'components/MetricsChart';
import { ChartDataArray } from 'components/chart/data/ChartDataArray';
import { ChartDataType } from 'components/chart/data/ChartDataType';
import { ChartData } from 'components/chart/data/ChartData';
import { useModelService } from 'services/model/model.service';
import { BarChartConfig } from 'components/chart/data/BarChartConfig';
import { BarChartRenderer } from 'components/chart/renderer/BarChartRenderer';
import { useIntl } from 'react-intl';
import { TileContent } from 'components/Layout/PageContainer';
import { getArrayWithIsOthers } from 'pages/insights-pro/common/graphs/getArrayWithIsOthers';
import { CategoryInfo, CountryInfo } from '../model';

interface CountriesCategorySharesProps {
  categories: CategoryInfo[];
  countries: CountryInfo[];
}

export function CountriesCategoryShares({ categories, countries }: CountriesCategorySharesProps) {
  const { getMeasureByMetric } = useModelService();

  const intl = useIntl();

  const ordGmvVal = getMeasureByMetric('ordGmvVal', 'OD');

  const createMarketplacesChartConfig = () => {
    const countriesChartConfig = new BarChartConfig();
    countriesChartConfig.breakdownMode = 'fill-stacked';
    countriesChartConfig.value = {
      code: ordGmvVal.code,
      label: ordGmvVal.metric.name,
      unit: ordGmvVal.metric.unit,
    };
    countriesChartConfig.legendConfig = {
      hide: false,
    };
    const reversedCountries = countries
      .sort((a, b) => b.totalGmv - a.totalGmv)
      .slice(0, 5)
      .reverse();
    countriesChartConfig.data = [
      new ChartDataArray(
        ChartDataType.primary,
        'all',
        reversedCountries.map(country => new ChartData(country.name, country.totalGmv))
      ),
      ...getArrayWithIsOthers(categories, [ordGmvVal.code], intl, c => c).map(category => {
        const array = new ChartDataArray(
          ChartDataType.breakdown,
          category.name,
          reversedCountries.map(country => {
            const countryCategory = getArrayWithIsOthers(country.categories, [ordGmvVal.code], intl, c => c).find(
              mc => mc.name === category.name
            );
            return new ChartData(country.name, ordGmvVal.getValue(countryCategory?.entry.values));
          })
        );
        array.color = category.color;
        return array;
      }),
    ];

    return countriesChartConfig;
  };

  const countriesChartRenderer = new BarChartRenderer(createMarketplacesChartConfig());

  return (
    <TileContent className="px-0">
      <MetricsChart renderer={countriesChartRenderer} height="h-[400px]" />
    </TileContent>
  );
}
